export default "__VITE_ASSET__CokB6to7__"